export default __webpack_public_path__ + "static/media/cardiovascular@2x.0eecef59.jpg";